// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7fe41ab7","788":"7850ec6e"}[chunkId] + ".chunk.js";
};